import Repository from "../../services/Repository"


const reSource = '/User';


export default {
    get(data) {
        return Repository.post(`${reSource}/list-filtered`, data)
    },
    editIsAdmin(query){
        return Repository.get(`${reSource}/UserAdmin`+ query );
    }
}
